import { Calendar, CheckCircle, Wand2 } from "lucide-react"

import { FrontendTriggerDefinition } from "@/components/automations/types"

export const meetingTriggers: FrontendTriggerDefinition[] = [
  {
    key: "trigger__meeting_scheduled",
    label: "Meeting scheduled",
    description: "Triggers when a new meeting is scheduled",
    icon: Calendar,
    providesSubjects: ["meeting", "household"],
    inputFields: [
      {
        key: "meeting_types",
        label: "Meeting type",
        inputType: "multi_select",
        required: false,
        options: "dynamic_meeting_types",
      },
      {
        key: "filter_group",
        label: "Continue if...",
        inputType: "filter_group",
        required: false,
        filterEntity: "meeting",
      },
    ],
  },
  {
    key: "trigger__meeting_completed",
    label: "Meeting completed",
    description: "Triggers when a meeting is completed",
    icon: CheckCircle,
    providesSubjects: ["meeting", "household"],
    inputFields: [
      {
        key: "meeting_types",
        label: "Meeting type",
        inputType: "multi_select",
        required: false,
        options: "dynamic_meeting_types",
      },
      {
        key: "filter_group",
        label: "Continue if...",
        inputType: "filter_group",
        required: false,
        filterEntity: "meeting",
      },
    ],
  },
  {
    key: "trigger__meeting_magic_button",
    label: "Magic button",
    description: "Triggers when a magic button is pressed for a meeting",
    icon: Wand2,
    providesSubjects: ["meeting", "household"],
    inputFields: [
      {
        key: "title",
        label: "Button title",
        inputType: "text",
        required: true,
        placeholder: "e.g., Request review",
      },
      {
        key: "description",
        label: "Description",
        inputType: "textarea",
        required: false,
        placeholder: "What does this button do?",
      },
      {
        key: "icon_color",
        label: "Icon & color",
        inputType: "icon_color_picker",
        required: false,
        iconOptions: [
          "wand",
          "sparkles",
          "zap",
          "brain",
          "bot",
          "dollar",
          "coins",
          "banknote",
          "piggy-bank",
          "landmark",
          "chart-line",
          "chart-pie",
          "briefcase",
          "phone",
          "mail",
          "send",
          "calendar",
          "clock",
          "bell",
          "document",
          "household",
          "handshake",
          "star",
          "check",
        ],
        colorFormat: "hex",
      },
    ],
  },
]
